module.exports = __webpack_public_path__ + "media/images/3-61253f8cae39b4f21e36003083dfbc67.jpg";